import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { ReservationLinkResult } from '@mews-commander/data-access';
import { WithAccountId } from '@mews-commander/types';
import { getReservationById } from '../../tables/PaymentPlans/utils';
import { CreatePaymentPlanFormValues } from './schema';
import { useGetReservationsForCreatePaymentPlanSuspense } from './hooks';
import { CreatePaymentPlanFormField } from './types';

export const PaymentPlanReservationFormContent = ({
    renderContent,
    accountId,
}: {
    renderContent: (props: { reservation: ReservationLinkResult }) => ReactNode;
} & WithAccountId) => {
    const { watch } = useFormContext<CreatePaymentPlanFormValues>();
    const reservations = useGetReservationsForCreatePaymentPlanSuspense({ accountId });

    const selectedReservationId = watch(CreatePaymentPlanFormField.ReservationId);
    const selectedReservation = getReservationById(reservations, selectedReservationId);

    return <>{selectedReservation ? renderContent({ reservation: selectedReservation }) : null}</>;
};
